import { FETCH_MODULE, FETCH_MODULE_SUCCESS, FETCH_MODULE_FAIL } from 'actions/module';

const initialState = {
  isLoading: false,
  modules: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const moduleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_MODULE: {
      return { ...state, isLoading: true };
    }

    case FETCH_MODULE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        modules: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_MODULE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default moduleReducer;
